import { render, staticRenderFns } from "./RouterButton.vue?vue&type=template&id=6a567387&scoped=true&"
import script from "./RouterButton.vue?vue&type=script&lang=js&"
export * from "./RouterButton.vue?vue&type=script&lang=js&"
import style0 from "./RouterButton.vue?vue&type=style&index=0&id=6a567387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a567387",
  null
  
)

export default component.exports